export const EDUCATION_TEST_QUESTION_BANK_ITEMS = [];

export const EDUCATION_TEST_QUIZ_CASE_OPTIONS = [
  { id: 'option-1', name: 'Safety briefing' },
  { id: 'option-2', title: 'Fire safety' },
  'Guest service',
];
